import { render } from "./index.vue?vue&type=template&id=1a3bf5c0&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=1a3bf5c0&lang=scss&scoped=true"

import exportComponent from "D:\\McToWebsite\\www\\CustomerWork\\XiJiangDairy\\OfficialWebsite\\System\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a3bf5c0"]])

export default __exports__